export default function PlanCardsCarouselSkeleton() {
	return (
		<div className="flex w-full max-w-full snap-x snap-mandatory gap-8 overflow-hidden pb-8 before:w-8 after:w-8 sm:scroll-pl-0 sm:before:hidden sm:after:hidden">
			{Array.from({ length: 3 }).map((_, i) => (
				<div key={i} className="min-w-[18rem] shrink-0 space-y-4">
					<div className="h-[28rem] animate-pulse rounded-2xl bg-secondary/10" />
				</div>
			))}
		</div>
	);
}
